const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSToothCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconS-tooth-crown",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconS-tooth-crown1",
    serifid: "iconS-tooth-crown"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.235,15.922c-0.891,-1.694 -1.216,-3.745 -0.701,-5.905c0.673,-2.827 2.885,-5.124 5.631,-5.858c1.439,-0.375 2.824,-0.032 4.094,0.648l6.152,4.038c0.474,0.312 1.079,0.133 1.354,-0.305c0.29,-0.461 0.16,-1.077 -0.299,-1.382l-1.729,-1.133c0.214,-0.109 0.444,-0.195 0.643,-0.344c1.599,-1.202 3.481,-2.046 5.455,-1.523c2.747,0.734 4.959,3.03 5.631,5.858c0.513,2.162 0.192,4.217 -0.699,5.906l-5.911,0l-0,-1.142c-0,-0.631 -0.512,-1.143 -1.143,-1.143l-11.426,-0c-0.631,-0 -1.143,0.512 -1.143,1.143l0,1.142l-5.909,0Zm24.118,2.285c-0.862,1.665 -1.256,3.511 -1.431,5.416c-0.268,2.952 -0.627,5.889 -1.278,8.77l-0.482,2.117c-0.191,0.867 -0.949,1.484 -1.813,1.484c-0.857,-0 -1.599,-0.594 -1.806,-1.445l-2.112,-8.656c-0.28,-1.138 -1.28,-1.938 -2.43,-1.938c-1.155,0 -2.157,0.804 -2.433,1.945l-2.112,8.655c-0.206,0.852 -0.956,1.445 -1.806,1.445c-0.872,0 -1.622,-0.617 -1.821,-1.484l-0.474,-2.117c-0.651,-2.882 -1.01,-5.819 -1.222,-8.77c-0.219,-1.955 -0.622,-3.771 -1.483,-5.422l5.638,0c0.631,0 1.143,-0.512 1.143,-1.142l-0,-1.143l9.141,0l0,1.143c0,0.63 0.512,1.142 1.143,1.142l5.638,0Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSToothCrown);
export default __webpack_public_path__ + "static/media/iconS-tooth-crown.8f67db7f781b1f2c4b189349dd447dcd.svg";
export { ForwardRef as ReactComponent };